import SettingsMobileListControls from "@/components/SettingsMobileListControls/SettingsMobileListControls.vue";

const settings_tariff_book_table_helpers = window.global_data_table?.create_component_helpers({
    selector: ".global_data_table"
}) || {};

export default {
    name: "SettingsTariffBookTab",

    components: {
        SettingsMobileListControls
    },

    props: {
        tariff_books: {
            type: Array,
            default: () => []
        },
        tariffs: {
            type: Array,
            default: () => []
        },
        tariff_rates: {
            type: Array,
            default: () => []
        },
        format_date: {
            type: Function,
            required: true
        }
    },

    data() {
        return ({
            open_tariff_book_id: null,
            mobile_tariff_pages: {},
            mobile_tariff_searches: {},
            mobile_page_size: 5
        });
    },

    computed: {
        tariff_book_rows() {
            return this.tariff_books.map((tariff_book) => {
                const linked_tariffs = this.tariffs.filter((tariff) => {
                    return Number(tariff.tariff_book_id) === Number(tariff_book.id);
                }).map((tariff) => {
                    const rate_versions = this.tariff_rates
                        .filter((rate) => Number(rate.tariff_id) === Number(tariff.id))
                        .sort((first_rate, second_rate) => {
                            const first_effective_from = new Date(first_rate?.effective_from || 0).getTime();
                            const second_effective_from = new Date(second_rate?.effective_from || 0).getTime();

                            return second_effective_from - first_effective_from;
                        });

                    return ({
                        ...tariff,
                        rate_versions,
                        rate_version_count: rate_versions.length,
                        latest_rate_version: rate_versions[0] || null,
                        latest_charge_component_count: Object.keys(rate_versions[0]?.rates || {}).length
                    });
                });

                return ({
                    ...tariff_book,
                    rate_total: linked_tariffs.reduce((total, tariff) => total + tariff.rate_version_count, 0),
                    tariff_total: linked_tariffs.length,
                    primary_rate_name: linked_tariffs[0]?.name || "",
                    rate_names: linked_tariffs.map((tariff) => tariff.name).filter(Boolean),
                    linked_tariffs
                });
            });
        }
    },

    watch: {
        ...(settings_tariff_book_table_helpers.watch || {}),
        tariff_book_rows: {
            immediate: true,
            handler(next_rows) {
                if (!next_rows.length) {
                    this.open_tariff_book_id = null;
                    return;
                }

                const has_open_row = next_rows.some((row) => Number(row.id) === Number(this.open_tariff_book_id));

                if (!has_open_row) {
                    this.open_tariff_book_id = next_rows[0].id;
                }

                this.rebuild_tables?.();
            }
        },
        open_tariff_book_id() {
            this.rebuild_tables?.();
        }
    },

    mounted: settings_tariff_book_table_helpers.mounted,

    beforeUnmount: settings_tariff_book_table_helpers.beforeUnmount,

    methods: {
        ...(settings_tariff_book_table_helpers.methods || {}),
        toggle_tariff_book(tariff_book_id) {
            this.open_tariff_book_id = Number(this.open_tariff_book_id) === Number(tariff_book_id)
                ? null
                : tariff_book_id;
        },

        is_tariff_book_open(tariff_book_id) {
            return Number(this.open_tariff_book_id) === Number(tariff_book_id);
        },

        get_mobile_tariff_page(tariff_book_id) {
            return this.mobile_tariff_pages[String(tariff_book_id)] || 1;
        },

        get_mobile_tariff_page_count(tariffs = []) {
            return Math.max(1, Math.ceil(tariffs.length / this.mobile_page_size));
        },

        get_mobile_tariff_search(tariff_book_id) {
            return this.mobile_tariff_searches[String(tariff_book_id)] || "";
        },

        get_filtered_mobile_tariffs(tariff_book) {
            const search = this.get_mobile_tariff_search(tariff_book.id).trim().toLowerCase();

            if (!search) return tariff_book.linked_tariffs;

            return tariff_book.linked_tariffs.filter((tariff) => {
                return this.get_mobile_tariff_search_text(tariff).includes(search);
            });
        },

        get_mobile_tariff_search_text(tariff) {
            return [
                tariff?.name,
                tariff?.tariff_type,
                tariff?.code,
                tariff?.tariff_category
            ].join(" ").toLowerCase();
        },

        get_paginated_mobile_tariffs(tariff_book) {
            const page = this.get_mobile_tariff_page(tariff_book.id);
            const start_index = (page - 1) * this.mobile_page_size;

            return this.get_filtered_mobile_tariffs(tariff_book).slice(start_index, start_index + this.mobile_page_size);
        },

        set_mobile_tariff_page(tariff_book, page) {
            const next_page = Math.min(
                Math.max(Number(page), 1),
                this.get_mobile_tariff_page_count(this.get_filtered_mobile_tariffs(tariff_book))
            );

            this.mobile_tariff_pages = {
                ...this.mobile_tariff_pages,
                [String(tariff_book.id)]: next_page
            };
        },

        set_mobile_tariff_search(tariff_book, search) {
            this.mobile_tariff_searches = {
                ...this.mobile_tariff_searches,
                [String(tariff_book.id)]: search
            };
            this.set_mobile_tariff_page(tariff_book, 1);
        }
    },

    emits: [
        "view-rates"
    ]
};
